export type CharacteristicType = {
  id: string,
  fallbacks?: string[],
  name: string,
  icon: string
  faIcon: string,
  icon_name: string,
  placeholder: string,
}

const Characteristics: CharacteristicType[] = [{
  id: "marital_status",
  fallbacks: ['family', 'fiancee'],
  name: "Burgerlijke staat",
  icon: "family",
  faIcon: "fa-solid fa-people-group",
  // "faIcon: "fa-solid fa-family",// pro
  icon_name: "Gezin",
  placeholder: "bijv. getrouwd/samenwonend met ... en 3 kinderen (Sophie, Karel, Anne) / Single / Gelukkig samenwonend met ..."
}, {
  id: "education",
  name: "Opleiding",
  icon: "graduation-cap",
  faIcon: "fa-solid fa-graduation-cap",
  icon_name: "Opleiding",
  placeholder: "bijv. Hogeschool van Amsterdam, Verpleegkunde"
}, {
  id: "work",
  name: "Werk",
  icon: "briefcase",
  faIcon: "fa-solid fa-briefcase",
  icon_name: "Werk",
  placeholder: "bijv. Tuinarchitect"
}, {
  id: "sport",
  name: "Sport",
  icon: "sportsball",
  // faIcon: "fa-solid fa-sportsball",// pro
  faIcon: "fa-solid fa-volleyball",
  icon_name: "Sport",
  placeholder: "bijv. voetbal, hardlopen"
}, {
  id: "hobby_leisure",
  name: "Hobby / vrije tijd",
  icon: "sportsball",
  faIcon: "fa-solid fa-tree",
  // faIcon: "fa-solid fa-ring",// pro
  icon_name: "hobbies",
  placeholder: "bijv. actief bij voetbalvereniging ... als ..."
}, {
  id: "food",
  name: "Eten",
  icon: "utensils",
  faIcon: "fa-solid fa-utensils",
  icon_name: "Eten",
  placeholder: "bijv. Thais en tosti's"
}, {
  id: "music",
  name: "Muziek",
  icon: "music",
  faIcon: "fa-solid fa-music",
  icon_name: "Muziek",
  placeholder: "bijv. The Beatles en ..."
}, {
  id: "pets",
  fallbacks: ['pet'],
  name: "Huisdier",
  icon: "paw-simple",
  // faIcon: "fa-solid fa-paw-simple", // pro
  faIcon: "fa-solid fa-paw",
  icon_name: "Huisdier",
  placeholder: "bijv. 2 katten (Minou en Lex)"
}, {
  id: "holiday",
  fallbacks: ['vacation'],
  name: "Vakantie",
  icon: "compass-sharp-regular",
  // faIcon: "fa-solid fa-compass-sharp-regular",//"fa-solid fa-compass", // pro
  faIcon: "fa-solid fa-compass",
  icon_name: "Vakantie",
  placeholder: "bijv. Favoriete vakantiebestemming was Italië"
}
];

export default Characteristics
